import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'shared/constants';
import { useService } from 'shared/providers';

export function useUsers() {
  const { userMappingService } = useService();

  const { data, isFetching } = useQuery([QUERY_KEYS.users], () => userMappingService.getUsers());

  return { users: data, isFetching } as const;
}
